import { useMutation, useQueryClient } from '@tanstack/react-query';
import { warehouseService } from '@services/warehouse';
import {
  MaterialCategory,
  MaterialCategoryCreateInput,
  MaterialCategoryUpdateInput,
} from '@models/warehouse.model';
import { MATERIAL_CATEGORIES_QUERY_KEY } from './useMaterialCategories';

export const useCreateMaterialCategory = () => {
  const queryClient = useQueryClient();

  return useMutation<MaterialCategory, Error, MaterialCategoryCreateInput>({
    mutationFn: (input) => warehouseService.createMaterialCategory(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MATERIAL_CATEGORIES_QUERY_KEY });
    },
  });
};

export const useUpdateMaterialCategory = () => {
  const queryClient = useQueryClient();

  return useMutation<MaterialCategory, Error, MaterialCategoryUpdateInput>({
    mutationFn: (input) => warehouseService.updateMaterialCategory(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MATERIAL_CATEGORIES_QUERY_KEY });
    },
  });
};

export const useDeleteMaterialCategory = () => {
  const queryClient = useQueryClient();

  return useMutation<{ affected: number }, Error, string>({
    mutationFn: (categoryId) => warehouseService.deleteMaterialCategory(categoryId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MATERIAL_CATEGORIES_QUERY_KEY });
    },
  });
};
